@if (_context) {
    <!-- <app-workflow-wizard
		[mode]="_context.formMode"
		[currentWorkflow]="_context.workflowContext.workflow"
		(workflowCreated)="onWorkflowCreated($event)"
		(workflowUpdated)="onWorkflowUpdated($event)"
		(workflowFinished)="onWorkflowFinished($event)"></app-workflow-wizard> -->
    <app-api-configuration-wizard [context]="_context" (apiConfigurationUpdated)="onApiConfigurationUpdated($event)"></app-api-configuration-wizard>
}
